import * as React from 'react';
import { Util } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';

const OrderConfirmDonation = ({ foundationKey  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", {
        className: "order-confirm-donation"
    }, /*#__PURE__*/ React.createElement(Text, {
        component: "p",
        className: "order-confirm-donation__heading"
    }, getLabel(`checkout.completed.donation.${foundationKey.toLowerCase()}.title`)), /*#__PURE__*/ React.createElement(Text, {
        variant: "caption",
        component: "p",
        className: "order-confirm-donation__description"
    }, getLabel(`checkout.completed.donation.${foundationKey.toLowerCase()}.description`)), Util.getDonationFoundationIcon(foundationKey));
};

export { OrderConfirmDonation };
//# sourceMappingURL=OrderConfirmDonation.js.map
